import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-case-type-assessment',
  templateUrl: './case-type-assessment.component.html',
  styleUrls: ['./case-type-assessment.component.scss']
})
export class CaseTypeAssessmentComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
